import React from "react";
import * as SC from "./PostEditorTwitter.styled.js";

import CampaignCreateTeaserEditor from "../../Campaign__Create_TeaserEditor/Campaign__Create_TeaserEditor.jsx";
import ChannelDataEditor from "../../Campaign__Create_ChannelDataEditor.jsx";
import CampaignCreatePerformanceEditor from "../../campaign-create-performance-editor/CampaignCreatePerformanceEditor.jsx";
import {
  TwitterCommentIcon,
  TwitterLikeIcon,
  TwitterShareIcon,
  TwitterRetweetIcon,
  TwitterLinkIcon
} from "../../Svg";
import { channelsByShortName } from "../../../../../data/app__channels";
import useMediaAssets from "./../hooks/useMediaAssets.js";
import TemplatePostPreview from "../../TemplatePost/TemplatePost__Preview/TemplatePostPreview.jsx";
import { useTranslation } from "react-i18next";

const PostEditorTwitter = ({
  orgaId,
  postData,
  channelData,
  updatePost,
  updateChannelData,
  mobile,
  editable,
  channel,
  selectedCreativeIndexToEdit,
  setSelectedCreativeIndexToEdit
}) => {
  const mediaAssets = useMediaAssets(postData);
  const { t } = useTranslation();

  const templatePreviewSizes = {
    minHeight: SC.TWITTER_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].minHeight,
    maxHeight: SC.TWITTER_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].maxHeight,
    width: SC.TWITTER_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].pictureWidth,
    minAspect: channelsByShortName.twitter.minAspect,
    maxAspect: channelsByShortName.twitter.maxAspect
  };

  return (
    <SC.PostEditorWrapper mobile={mobile}>
      <SC.Logo src="/images/twitter-icon.png" alt="" />
      <SC.BodyWrapper>
        <SC.HeaderWrapper>
          <SC.PageName>{channelData.pageName}</SC.PageName>
          <SC.TwitterAddressWrapper>@JobHappier · 6h</SC.TwitterAddressWrapper>
        </SC.HeaderWrapper>
        <SC.EditorWrapper>
          <CampaignCreateTeaserEditor
            channel="twitter"
            updatePost={updatePost}
            teaserText={postData.teaserText}
            editable={editable}
            teaserTextStyle={SC.teaserTextStyle}
            limit={channelsByShortName.twitter.limits.teaserText}
            minRows={3}
            isAutoGenerated={postData?.isAutoGenerated}
            autoGeneratedText={postData?.autoGeneratedText}
            isEdited={postData?.editedStates?.teaserText}
            rejectHashtags
          />
        </SC.EditorWrapper>
        <SC.LinkWrapper>
          <TemplatePostPreview
            orgaId={orgaId}
            creatives={postData.creatives}
            creativeAssets={postData.creativeAssets}
            selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
            mediaAssets={mediaAssets}
            updatePost={updatePost}
            channel={channel}
            editable={editable}
            templatePreviewSizes={templatePreviewSizes}
          />
          <SC.ChannelDataEditorsWrapper>
            <ChannelDataEditor
              updateChannelData={updateChannelData}
              value={channelData.title}
              dataKey="title"
              textStyle={SC.titleStyle}
              limit={channelsByShortName.twitter.limits.title}
              label={t("Job Title")}
              tooltip={t("Job Title")}
              editable={editable}
            />
            <ChannelDataEditor
              updateChannelData={updateChannelData}
              value={channelData.subHeadline}
              dataKey="subHeadline"
              textStyle={SC.subHeadlineStyle}
              limit={channelsByShortName.twitter.limits.subHeadline}
              label={t("Subtitle")}
              tooltip={t("Subtitle")}
              editable={editable}
            />
            <SC.DisplayLinkWrapper>
              <TwitterLinkIcon />
              <ChannelDataEditor
                updateChannelData={updateChannelData}
                value={channelData.displayLink}
                dataKey="displayLink"
                textStyle={SC.displayLinkStyle}
                limit={channelsByShortName.twitter.limits.displayLink}
                label={t("Displayed link")}
                tooltip={t("Displayed link")}
                bannedCharaters={["!", "?"]}
                editable={editable}
                urlValue={channelData.url}
              />
            </SC.DisplayLinkWrapper>
          </SC.ChannelDataEditorsWrapper>
        </SC.LinkWrapper>
        <SC.FooterWrapper>
          <SC.TwitterButton color="#249dd9">
            <TwitterCommentIcon />
          </SC.TwitterButton>
          <SC.TwitterButton color="#1fb866">
            <TwitterLikeIcon />
          </SC.TwitterButton>
          <SC.TwitterButton color="#cc3265">
            <TwitterShareIcon />
          </SC.TwitterButton>
          <SC.TwitterButton color="#249dd9">
            <TwitterRetweetIcon />
          </SC.TwitterButton>
        </SC.FooterWrapper>
        <CampaignCreatePerformanceEditor
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          editable={editable}
          channel={channel}
          mediaAssets={mediaAssets}
          updatePost={updatePost}
          padding="12px 0 0 0"
          selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
          setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
        />
      </SC.BodyWrapper>
    </SC.PostEditorWrapper>
  );
};

export default PostEditorTwitter;
